import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/BlogSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/HeroSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/ProductsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/SEOContentSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/WhyUsSection.tsx");
